
export type FastRetainerMode = 'creating' | 'refinement_uassist' | 'fromud_uassist'

/**
 * if isRefinement === true explanation it is refinement fast-retainer mode.
 * else explanation it is created from ud and need do fast-retainer to submit to uassist.
 */
export const checkFastRetainerMode = (searchParams: URLSearchParams) => {
  const fastRetainerMode: FastRetainerMode =
    searchParams.get("isRefinement") === "true"
      ? 'refinement_uassist'
      : searchParams.get("from") === "clinical"
      ? 'fromud_uassist'
      : 'creating'
  return fastRetainerMode
}
